<div  class="grid-container">
    <ag-grid-angular class="data-grid " [rowData]="productionReports" [gridOptions]="reportingGridOptions" [statusBar]="statusBar" aria-label="Production Reporting"></ag-grid-angular>
</div>